import ErrorBoundary from "../utils/ErrorHandler";

import LandingPageLayOut from "../views/LandingPageLayOut/LandingPageLayOut";
import LandingPage from "../views/LandingPage/LandingPage";
import Register from "../components/Landing-page-components/Register/Register";
import ForgotPassword from "../components/Landing-page-components/Register/ForgotPassword";
import AdminPanelLayOut from "../views/adminPanelLayOut/AdminPanelLayOut";
import { Navigate } from "react-router-dom";
import EmployeeManagement from "../pages/EmployeeManagement/EmployeeManagement";
import { EmployeeManagementLayOut } from "../views/EmployeeManagementLayOut/EmployeeManagementLayOut";
import AddStaff from "../pages/EmployeeManagement/AddStaff/AddStaff";
import UserInfo from "../pages/EmployeeManagement/UserInfo/UserInfo";
import SettingBody from "../setting/settingBody/SettingBody";
import CompanyDetails from "../setting/Company/CompanyDetails/CompanyDetails";
import SettingLayOut from "../views/settingLayOut/SettingLayOut";
import Branches from "../setting/Company/CompanyBranches/Branches";
import CompanyDepartments from "../setting/Company/CompanyDepartments/CompanyDepartments";
import Admins from "../setting/MyTeam/Admins/Admins";
import EmployeesManagers from "../setting/MyTeam/EmployeesManagers/EmployeesManagers";
import Shifts from "../setting/AttendanceSettings/Shifts/Shifts";
import HolidayModule from "../setting/AttendanceSettings/Holiday/Index";
import Holiday from "../setting/AttendanceSettings/Holiday/Holiday";
import Dashboard from "../pages/Dashboard/Dashboard";
import Designation from "../setting/Company/CompanyDesignation/Designation";
import Roles from "../setting/Company/CompanyRoals/Roles";
import ErrorPage from "../views/Error/ErrorPage";
import CompanyReports from "../setting/Company/CompanyReports/CompanyReports";
import Restaurant from "../pages/Restaurant/Index";
import Report from "../pages/Restaurant/Report";
import UserManagements from "../pages/Restaurant/UserManagement";
import Questionnaire from "../pages/Restaurant/Questionnaire/index";
import ReportQuestionnaire from "../pages/Restaurant/ReportQuestionnaire/index";
import AuditAssignedEmployee from "../pages/Restaurant/Employee/AssignedEmployeeList";
import OutletAssignedEmployee from "../pages/Restaurant/Employee/OutletAssignedEmployee";
import AnswerByEmployee from "../pages/Restaurant/Employee/AnswerByEmployee";
import QuestionList from "../pages/Restaurant/Employee/QuestionList";
import FormBuilder from "../pages/Restaurant/Questionnaire/FormBuilder";
import UpdateQuestionnaire from "../pages/Restaurant/Questionnaire/UpdateQuestionnaire";
import SuperAdminLayOut from "../views/superadminlayout/SuperAdminLayOut";
import UserManagement from "../pages/superAdmin/userManagement/UserManagement";
import SalaryDetails from "../setting/Salary/SalaryDetails";
import SalaryTemplate from "../setting/Salary/SalaryTemplate";
import UpdatePayroll from "../setting/Salary/UpdatePayroll";
import PayrollSetting from "../setting/Salary/Payroll";
import PayrollConfiguration from "../setting/settingBody/PayrollConfiguration/PayrollConfiguration";
import PayrollConfigurations from "../pages/Payroll/components/PayrollConfiguration";
import SuperAdminSettings from "../setting/SuperAdmin/index";
import SuperAdminDashboard from "../pages/superAdmin/dashboard/index";
import Attendance from "../pages/Attendance";
import LiveAttendance from "../pages/Attendance/LiveAttendance";
import DailyAttendance from "../pages/Attendance/DailyAttendance";
import AttendanceDashboard from "../pages/Attendance/AttendanceDashboard";
import MonthlyAttendance from "../pages/Attendance/MonthlyAttendance";
import MonthlyAttendanceReport from "../pages/Attendance/MonthlyAttendanceReport";
import EmployeeAttendance from "../pages/Attendance/EmployeeAttendance";
import MyEmployeeId from "../setting/Company/EmployeeId/EmployeeId";
import Tracking from "../pages/Tracking/Index";
import Package from "../pages/Package/Index";
import RolesAndPermission from "../pages/superAdmin/RolesAndPermission";
import SystemConfiguration from "../pages/superAdmin/SystemConfiguration";
import AuditTrail from "../pages/superAdmin/AuditTrail";
import DataBackupRestore from "../pages/superAdmin/DataBackupRestore";
import SecurityManagement from "../pages/superAdmin/SecurityManagement";
import IntegrationManagement from "../pages/superAdmin/IntegrationManagement";
import ModuleConfiguration from "../pages/superAdmin/ModuleConfiguration";
import AnnouncementNotification from "../pages/superAdmin/AnnouncementNotification";
import AccessControl from "../pages/superAdmin/AccessControl";
import ReportGeneration from "../pages/superAdmin/ReportGeneration";
import Troubleshooting from "../pages/superAdmin/Troubleshooting";
import EmployeeManager from "../setting/Company/EmployeeManager/Index";
import Breaks from "../setting/AttendanceSettings/Breaks/Breaks";
import PerformanceManagement from "../pages/Performance/Index";
import TrainingDevelopment from "../pages/TrainingDevelopment/Index";
import Onboarding from "../onboarding/employee/Index";
import ResetPassword from "../onboarding/resetPassword/Index";
import MoreSettings from "../setting/MoreSettings/MoreSettings";
import ShiftSetting from "../setting/MoreSettings/ShiftSettings";
import Notification from "../pages/Notification/Index";
import AddAnnouncement from "../pages/Notification/AddNotification"
import ShareModalPreview from "../pages/Notification/ShareModalPreview";
import MultiAttendance from "../pages/MultiAttendance/Index";
import UpdateAttendance from "../setting/MoreSettings/UpdateAttendance";
import LeaveSettings from "../setting/LeaveSettings/LeaveSettings";
import Leave from "../setting/LeaveSettings/Index";
import WelcomePage from "../onboarding/Welcome";
import CurrentDateEmployeeInfo from "../setting/settingBody/EmployeeInfo";
import Payroll from "../pages/Payroll/Index";
import RunPayroll from "../pages/Payroll/components/RunPayroll/RunPayroll";
import TdsSetting from "../setting/TDS/Index";
import EmployeeReviewDashboard from "../pages/Payroll/components/TDS/components/ui/ReviewComponents/MainContent";
import OvertimeSettings from "../pages/Attendance/OvertimeSettings";
// Redux --------------------------------------------------------------------
import { useSelector } from "react-redux";
import { Component } from "ag-grid-community";
import { components } from "react-select";

const Routes = () => {
  // const { dashboardUrl, signInUrl } = RouteUrls;
  const { superAdmin } = useSelector((state) => state.auth);

  const publicRoutes = [
    {
      path: "/",
      Component: <LandingPageLayOut />,
      children: [{ path: "", element: <LandingPage /> }],
    },
    { path: "/login", Component: <Register /> },
    { path: "/forgot-password", Component: <ForgotPassword /> },
  ];

  const privateRoutes = [
    {
      path: "",
      Component: superAdmin ? (
        <Navigate to={"/super-admin-panel"} />
      ) : (
        <ErrorBoundary>
          <AdminPanelLayOut />
        </ErrorBoundary>
      ),
      children: [
        { path: "", Component: <Navigate to={"dashboard"} /> },
        { path: "/dashboard", Component: <Dashboard /> },
        // Audit routes ---------------------------------------------------------------
        { path: "/audit", Component: <Restaurant /> },
        { path: "/audit/report", Component: <Report /> },
        { path: "/audit/report/questionnaire", Component: <ReportQuestionnaire />, },
        { path: "/user-management", Component: <UserManagements /> },
        { path: "/questionnaire", Component: <Questionnaire /> },
        { path: "/audit-assigned-employee", Component: <AuditAssignedEmployee />, },
        { path: "/outlet-assigned-employee", Component: <OutletAssignedEmployee />, },
        { path: "/audit-question-list", Component: <QuestionList /> },
        { path: "/audit-question-answer", Component: <AnswerByEmployee /> },
        { path: "/create-questionnaire", Component: <FormBuilder /> },
        { path: "/update-questionnaire", Component: <UpdateQuestionnaire /> },

{
    path: "/payroll/tds/review",
    component: <EmployeeReviewDashboard />
},


        // Report routes ---------------------------------------------------------------
        { path: "/reports", Component: <CompanyReports /> },
        // Attendance routes ---------------------------------------------------------------
        { path: "/attendance", Component: <Attendance /> },
        { path: "/live-attendance", Component: <LiveAttendance /> },
        { path: "/daily-attendance", Component: <DailyAttendance /> },
        { path: "/attendance-dashboard", Component: <AttendanceDashboard /> },
        { path: "/monthly-attendance", Component: <MonthlyAttendance /> },
       // ✅ Fixed (matches the navigate() URL)
{ path: "/attendance/monthly-attendance-report", Component: <MonthlyAttendanceReport />, },
        { path: "/live-attendance/employee-attendance", Component: <EmployeeAttendance />, },
        { path: "/daily-attendance/employee-attendance", Component: <EmployeeAttendance />, },
        // Tracking routes ---------------------------------------------------------------
        { path: "/tracking", Component: <Tracking /> },
        // Payroll routes ---------------------------------------------------------------
        { path: "/performance-management", Component: <PerformanceManagement />, },
        { path: "/payroll", Component: <Payroll /> },
        { path: "/raining-list", Component: <TrainingDevelopment /> },
        { path: "/run-payroll", Component: <RunPayroll /> },
        // Employee routes ---------------------------------------------------------------
        {
          path: "empmanagement",
          Component: <EmployeeManagementLayOut />,
          children: [
            { path: "", Component: <EmployeeManagement /> },
            { path: "add-staff", Component: <AddStaff /> },
            { path: "user-info/:id", Component: <UserInfo /> },
          ],
        },
        // Notification routes ---------------------------------------------------------------
        { path: "/notification", Component: <Notification />, },
        { path: "/share-preview", Component: <ShareModalPreview /> },
        { path: "/add-announcement", Component: <AddAnnouncement /> },
        // Settings routes ---------------------------------------------------------------
        {
          path: "setting",
          Component: (
            <SettingLayOut>
              <SettingBody />
            </SettingLayOut>
          ),
        },
        { path: "company-details", Component: <CompanyDetails /> },
        { path: "company_branches", Component: <Branches /> },
        { path: "company-designation", Component: <Designation /> },
        { path: "company-roles", Component: <Roles /> },
        { path: "company-reports", Component: <CompanyReports /> },
        { path: "my-employee-id", Component: <MyEmployeeId /> },
        { path: "company-departments", Component: <CompanyDepartments /> },
        { path: "myteam-admins", Component: <Admins /> },
        { path: "employee-manager", Component: <EmployeeManager /> },
        { path: "breaks", Component: <Breaks /> },
        { path: "myteam-Employees$Managers", Component: <EmployeesManagers />, },
        { path: "attendance-settings-shifts", Component: <Shifts />, },
        { path: "attendance-setting", Component: <MultiAttendance />, },
        { path: "overtime-settings", Component: <OvertimeSettings /> },
        { path: "holiday-module", Component: <HolidayModule />, },
        { path: "attendance-settings-holiday/:id", Component: <Holiday />, },
        { path: "more-attendance-settings", Component: <MoreSettings />,},
        { path: "update-module/:id", Component: <UpdateAttendance />, },
        { path: "shift-attendance-settings", Component: <ShiftSetting />, },
        { path: "leave-module", Component: <Leave />, },
        { path: "leave-attendance/:id", Component: <LeaveSettings />, },
        { path: "salary-details", Component: <SalaryDetails />, },
        // payroll-model routes ---------------------------------------------------------------
        { path: "payroll-model", Component: <PayrollSetting />, },
        { path: "update-payroll-model", Component: <UpdatePayroll />, },
        { path: "payroll-template", Component: <SalaryTemplate />, },
        { path: "payroll-configuration", Component: <PayrollConfiguration />, },
        { path: "payroll-configurations", Component: <PayrollConfigurations />, },
        { path: "current-date-employee-info", Component: <CurrentDateEmployeeInfo />, },
        // TDS Settings routes ---------------------------------------------------------------
        { path: "tds-setting", Component: <TdsSetting />, },
      ],
    },
    // Super admin path start from here ------------------------------------------------------
    {
      path: "super-admin-panel",
      Component: superAdmin ? (
        <ErrorBoundary>
          {" "}
          <SuperAdminLayOut />{" "}
        </ErrorBoundary>
      ) : (
        <Navigate to={""} />
      ),
      children: [
        { path: "", Component: <Navigate to={"dashboard"} /> },
        { path: "dashboard", Component: <SuperAdminDashboard /> },
        { path: "user-management", Component: <UserManagement /> },
        { path: "package", Component: <Package /> },
        { path: "roles-and-permission", Component: <RolesAndPermission /> },
        { path: "system-configuration", Component: <SystemConfiguration /> },
        { path: "audit-trail", Component: <AuditTrail /> },
        { path: "data-backup-store", Component: <DataBackupRestore /> },
        { path: "security-management", Component: <SecurityManagement /> },
        { path: "integration-management", Component: <IntegrationManagement />, },
        { path: "module-configuration", Component: <ModuleConfiguration /> },
        { path: "announcement-and-notification", Component: <AnnouncementNotification />, },
        { path: "access-control", Component: <AccessControl /> },
        { path: "report-generation", Component: <ReportGeneration /> },
        { path: "troubleshooting", Component: <Troubleshooting /> },
        {
          path: "setting",
          Component: (
            <SettingLayOut>
              <SuperAdminSettings />
            </SettingLayOut>
          ),
          // children: [{ path: "", Component: <h1>Hello</h1> }],
        },
      ],
    },

    { path: "*", Component: <ErrorPage /> },
  ];

  const onboardingRoute = [
    {
      path: "/employee/onboarding/:id",
      Component: (
        <ErrorBoundary>
          <Onboarding />
        </ErrorBoundary>
      ),
    },
    { path: "/welcome", Component: <WelcomePage /> },
    {
      path: "/resetpassword/:id",
      Component: (
        <ErrorBoundary>
          <ResetPassword />
        </ErrorBoundary>
      ),
    },
  ];

  return { privateRoutes, publicRoutes, onboardingRoute };
};

export default Routes;
